import styled, { keyframes } from 'styled-components';

const dotFlashing = keyframes`
  0% { 
    opacity: 0.2;
  }
  20% { 
    opacity: 1;
  }
  100% { 
    opacity: 0.2;
  }
`;

export const Container = styled('div')`
  display: flex;
  align-items: center;
  padding: 0.5rem 0;
`;

export const Dot = styled('span')`
  width: 6px;
  height: 6px;
  margin: 0 2px;
  background-color: #333;
  border-radius: 100%;
  display: inline-block;
  animation: ${dotFlashing} 1s infinite ease-in-out;

  &:nth-child(2) {
    animation-delay: 0.2s;
  }
  &:nth-child(3) {
    animation-delay: 0.4s;
  }
`;
